<script lang="ts">
	import { page } from '$app/state';
	import { signIn } from '$lib/auth/client.svelte';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import LoginPresentation from '$lib/components/map/mapTools/controls/login/LoginPresentation.svelte';
	import ModalDialog from '$lib/components/modals/ModalDialog.svelte';
	import { PROFILE_FAVORITES } from '$lib/constants/route';
	import { showElementAfterDidomiModal } from '$lib/services/tracking/didomi/consent';
	import { trackAccountModalVisibility, trackLoginButtonClick } from '$lib/services/tracking/googleAnalytics/accountModal';
	import { getSearchParamsStore } from '$lib/services/urls/searchParams';
	import * as m from '$paraglide/messages';

	const isUserLoggedIn = $derived(!!page.data.userSession);
	const searchParams = getSearchParamsStore();
	let modalIsOpen = $state(false);
	let profilePage = $state<string | undefined>(PROFILE_FAVORITES);

	function login() {
		signIn(profilePage === 'none' ? undefined : profilePage);
		$searchParams.showModal = undefined;
		$searchParams.redirectUserTo = undefined;

		closeModal();
	}

	function openModal() {
		if (window.Didomi?.notice?.isVisible()) {
			showElementAfterDidomiModal(openModal);
			return;
		}

		modalIsOpen = true;
		profilePage = $searchParams.redirectUserTo ?? PROFILE_FAVORITES;
		trackAccountModalVisibility();
	}

	function closeModal() {
		modalIsOpen = false;
		profilePage = PROFILE_FAVORITES;
		$searchParams.showModal = undefined;
		$searchParams.redirectUserTo = undefined;
	}

	$effect(() => {
		if ($searchParams?.showModal === 'login') {
			openModal();
		}
	});
</script>

<ModalDialog
	bind:open={modalIsOpen}
	closeCallback={closeModal}
	hideCloseButton
	paneClasses="flex justify-center md:grid md:place-items-center bg-neutral-weak md:bg-transparent text-body"
>
	<div class="p-2 md:p-0">
		<div class="md:hidden w-full p-2">
			<Button
				variant="filled"
				color="light"
				size="md"
				icon="west"
				text={m.action__back()}
				onclick={closeModal}
			/>
		</div>
		<LoginPresentation onClickLogin={login} locale={page.data.locale} />
	</div>
</ModalDialog>

{#if !isUserLoggedIn}
	<Button
		variant="filled"
		color="white"
		size="sm"
		icon="account-circle"
		ariaLabel={m.map_controls__aria_labels__login_profile()}
		onclick={() => {
			trackLoginButtonClick();
			openModal();
		}}
	/>
{:else}
	<Link
		ariaLabel={m.map_controls__aria_labels__access_profile()}
		button="filled"
		color="white"
		size="sm"
		icon="account-connected"
		href={profilePage ?? PROFILE_FAVORITES}
	/>
{/if}
